<template>
  <div>
    <b-table
      class="has-text-left"
      :data="students"
      mobile-cards
      :per-page="perPage"
      :paginated="paginated"
    >
      <b-table-column field="email" label="Student" v-slot="props">
        {{ props.row.email }}
      </b-table-column>

      <b-table-column centered field="actions" label="Actions" v-slot="props">
        <router-link
          class="is-info mr-3"
          :to="studentRecordingsPath(props.row.studentGuid)"
        >
          See recordings
        </router-link>
        <router-link
          class="is-info mr-3"
          :to="studentProgressPath(props.row.studentGuid)"
        >
          Progress report
        </router-link>
        <a
          class="has-text-danger"
          @click="disconnectClick(props.row.studentGuid, props.row.email)"
          :loading="disconnectingStudent[props.row.studentGuid]"
        >
          Disconnect
        </a>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import dataService from "../../services/dataService";
export default {
  props: ["students"],
  data() {
    return {
      perPage: 50,
      studentGuidToDisconnect: undefined,
      disconnectingStudent: {} // per student guid
    };
  },
  computed: {
    paginated() {
      return this.students.length > this.perPage;
    }
  },
  methods: {
    async disconnect() {
      this.$set(this.disconnectingStudent, this.studentGuidToDisconnect, true);
      const success = await dataService.disconnectStudent(
        this.studentGuidToDisconnect
      );
      if (success) await this.$emit("disconnect", this.studentGuidToDisconnect);
      this.$set(this.disconnectingStudent, this.studentGuidToDisconnect, false);
    },
    async disconnectClick(studentGuid, studentEmail) {
      this.studentGuidToDisconnect = studentGuid;
      this.$buefy.dialog.confirm({
        message: `Student ${studentEmail} will be disconnected and you will no longer be their tutor. Do you wish to continue?`,
        onConfirm: async () => await this.disconnect()
      });
    },
    studentRecordingsPath(studentGuid) {
      return `/students/${studentGuid}/recordings`;
    },
    studentProgressPath(studentGuid) {
      return `/progress/${studentGuid}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
